export default __webpack_public_path__ + "static/media/sounds/spelling_practice_instruction_active_alyx.mp3";